import * as Types from '@/types';

import { gql } from '@apollo/client';
export const SaveSalesPortalCart_MetadataFieldsFragmentDoc = gql`
  fragment SaveSalesPortalCart_MetadataFields on SalesPortalCartMetadataOutput {
    order_id
    restaurant_id
    supplier_id
    updated_at
    delivery_date
    fulfillment_timeslot_end
    fulfillment_timeslot_start
    fulfillment_type
  }
`;
export const SaveSalesPortalCart_CartItemFieldsFragmentDoc = gql`
  fragment SaveSalesPortalCart_CartItemFields on SalesPortalCartItemOutput {
    added_at
    quantity
    variant_pack_id
    order_item_id
  }
`;
export const SaveSalesPortalCart_ErrorFieldsFragmentDoc = gql`
  fragment SaveSalesPortalCart_ErrorFields on SalesPortalCartError {
    code
    message
  }
`;
